import { render, staticRenderFns } from "./ArticleVideo.vue?vue&type=template&id=6ba04276&scoped=true&"
import script from "./ArticleVideo.vue?vue&type=script&lang=js&"
export * from "./ArticleVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba04276",
  null
  
)

export default component.exports